export default __webpack_public_path__ + "content/3a8109c4ac75662f83556aa4a3addc75.woff2";